import { Controller } from "stimulus";
import Glightbox from 'glightbox';

export default class extends Controller {

  connect() {
    let lightbox = new Glightbox({
      selector: '.Gallery-lightbox__grid-item .js-Lightbox',
      zoomable: true,
      draggable: true,
      dragToleranceY: 10,
    });

    lightbox.on('open', () => {
      console.log('lightbox opened');
    });

   window.addEventListener('lightbox-open', this.openLightbox.bind(this))

  }

  openLightbox() {
    this.element.classList.add('Lightbox__open')
  }

  closeModal(event) {
    event.preventDefault()
    this.element.classList.remove('Lightbox__open')
  }
}
